<template>
    <main>
       <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Create Multi Branch</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
              
            </div>
        </div>
        <GenericNew v-if="generic" ref="loadGeneric" :urls="urls"></GenericNew>
        <CustomNew v-else></CustomNew>
    </main> 
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/MultiBranchs/MenuList.vue";
import lang from "@/views/modules/MultiBranchs/language/en";
import GenericNew from "@/components/layout/shared/generic/NewView.vue";
import CustomNew from "@/views/modules/MultiBranchs/NewView.vue";

export default {
name: "new-branch",
components: {
        breadcrumbs, 
        GenericNew,
        CustomNew
    },
    data(){
        return {
            generic: false,
            metaList:[],            
            urls:'api/modules/multibranchs',            
            routePath:{
                path:'multibranchs',
                detail:false
            }            
        }
    },
    mounted() {
        this.childMethod()
    },
    methods:{
        childMethod(){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
           
        }
    },
}
</script>
